import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Link, Stack, styled } from '@mui/material';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
import useActiveOffice from 'new/hooks/useActiveOffice';
import React, { useState } from 'react';
import {
  SIDEBAR_COLLAPSED_WIDTH,
  SIDEBAR_EXPANDED_WIDTH,
} from './AppBar/Sidebar';
import { TENANT } from 'new/tenants';
// import { useGetBilling } from 'new/modules/BillingPage/hooks';

export const BANNER_HEIGHT = 40;

const Banner = styled(Stack, {
  shouldForwardProp: (prop) => !['isExpanded'].includes(prop as string),
})<{
  isExpanded: boolean;
}>(({ theme, isExpanded }) => ({
  transition: 'padding-left 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  width: '100%',
  height: BANNER_HEIGHT,
  backgroundColor: TENANT.bannerBackground,
  color: 'black',
  paddingLeft: isExpanded ? SIDEBAR_EXPANDED_WIDTH : SIDEBAR_COLLAPSED_WIDTH,
  justifyContent: 'center',
  alignItems: 'center',
  fontFamily: 'Epilogue',
  fontSize: '0.955rem',
  fontWeight: 'bold',
  gap: theme.spacing(1),
}));

const CallToAction = styled(Link)(() => ({
  color: '#222222',
  fontFamily: 'Epilogue',
  fontSize: '0.955rem',
  fontWeight: 'bold',
  //textTransform: 'uppercase',
  textDecoration: 'none',
  '&:visited': {
    color: '#222222',
  },
  '&:hover': {
    color: '#222222',
    textDecoration: 'none',
  },
}));

const Close = styled(Button)(() => ({
  color: 'black',
  fontFamily: 'Epilogue',
  fontSize: '0.875rem',
  fontWeight: 'bold',
  position: 'absolute',
  right: 35,
}));

type Props = {
  isExpanded: boolean;
};

const GlobalBanner: React.FC<Props> = ({ isExpanded }) => {
  const [, setHasBanner] = useState(cookies.get('banner_hidden') == undefined);
  const {
    globalBanner,
    // activeOfficeId
  } = useActiveOffice();
  // const { data: billing } = useGetBilling(activeOfficeId);

  const show = cookies.get('banner_hidden') == undefined;

  const hide = () => {
    cookies.set('banner_hidden', true, { path: '/' });
    setHasBanner(false);
  };

  // if (billing?.BillingData.pmsData.pmsSubscriptionState == 'active')
  //   return (
  //     <Banner isExpanded={true} direction="row">
  //       <Box>
  //         Our PMS integration API is currently expriencing issues. Please reach
  //         out to <a href="mailto:success@dentalhq.com">success@dentalhq.com</a>{' '}
  //         with any questions.
  //       </Box>
  //     </Banner>
  //   );
  // else
  if (!globalBanner || !show) return null;
  else
    return (
      <Banner isExpanded={isExpanded} direction="row">
        <Box>{globalBanner.message}</Box>
        <CallToAction target="_blank" href={globalBanner.callToActionLink}>
          {globalBanner.callToAction}
        </CallToAction>
        <Close onClick={hide}>
          <FontAwesomeIcon icon={faTimes} />
        </Close>
      </Banner>
    );
};

export default GlobalBanner;
